import { makeStyles } from '@mui/styles';
export const stickyWidths = [150, 200, 250, 200, 100, 100];
export const flightAndAncillaryETicketSummaryListStyles = makeStyles((theme) => {
	// ajustá según necesidad

	const stickyClasses = stickyWidths.reduce(
		(acc, width, index) => {
			const left = stickyWidths.slice(0, index).reduce((sum, w) => sum + w, 0);
			acc[`sticky${index + 1}`] = {
				position: 'sticky',
				left,
				background: theme.palette.background.paper,
				zIndex: 1020,
				minWidth: width,
				boxSizing: 'border-box',
				display: 'table-cell',
			};
			return acc;
		},
		{} as Record<string, any>,
	);
	return {
		...stickyClasses,
		backdrop: {
			zIndex: theme.zIndex.modal + 1,
			color: '#fff',
		},
		tableHeader: {
			backgroundColor: theme.palette.grey.A400,
		},
		paginationHolder: {
			marginTop: theme.spacing(1),
			padding: 10,
			justifyContent: 'center',
			alignItems: 'center',
			display: 'flex',
		},
		btnContainer: {
			display: 'flex',
			justifyContent: 'space-around',
			maxWidth: '90px',
		},
		expandedRow: {
			backgroundColor: '#FFE2D3',
		},
		icon: {
			color: '#AB47BC',
		},
		container: {
			paddingBottom: 20,
			borderBottom: '1px solid #00000040',
			width: '85%',
		},
		containerButtons: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		tableSortLabel: {
			color: theme.palette.grey.A700,
			'&:hover': {
				color: theme.palette.common.black,
			},
		},
		tableContainer: {
			overflowX: 'scroll',
			'&::-webkit-scrollbar': {
				height: '10px',
			},
			'&::-webkit-scrollbar-thumb': {
				backgroundColor: theme.palette.primary.main,
				borderRadius: '5px',
			},
			'&::-webkit-scrollbar-track': {
				backgroundColor: 'rgba(0, 0, 0, 0.2)',
			},
		},
		cellNoWrap: {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
		hoverRow: {
			'&:hover': {
				backgroundColor: theme.palette.action.hover,
			},
		},
		stickyFirst: {
			position: 'sticky',
			left: 0,
			background: theme.palette.background.paper,
			zIndex: 1020,
			minWidth: 160,
			boxSizing: 'border-box',
			display: 'table-cell',
		},
		stickySecond: {
			position: 'sticky',
			left: 160,
			background: theme.palette.background.paper,
			zIndex: 1020,
			minWidth: 166,
			boxSizing: 'border-box',
			display: 'table-cell',
		},
		stickyThird: {
			position: 'sticky',
			left: 160 + 166,
			background: theme.palette.background.paper,
			zIndex: 1020,
			minWidth: 70,
			boxSizing: 'border-box',
			display: 'table-cell',
		},
		stickyFour: {
			position: 'sticky',
			left: 160 + 166 + 120,
			background: theme.palette.background.paper,
			zIndex: 1020,
			minWidth: 70,
			boxSizing: 'border-box',
			display: 'table-cell',
		},
		clickableCell: {
			cursor: 'pointer',
		},
	};
});
